<template xmlns="http://www.w3.org/1999/html">
  <div style="width: 100%;margin: 0 auto">
<!--    <prohead></prohead>-->
    <div class="banner" style="  background: url('../../static/img/999.png');">
      <div style="position: absolute;left: 42%">产业更新 融合为势</div>
    </div>
    <div class="box5_banner" style="padding-top: 40px;" >

      <div>
        <ul class="tab-title">
          <li v-for="(title,index) in tabTitle" @click="cur=title.cate_name" :class="{active:cur==title.cate_name}">{{title.cate_name}}</li>
        </ul>
      </div>

    </div>
    <div class="boxyin" id="ryzz" v-show="cur == '市场前景'">
      <div style="text-align: center">
        <div class="titlebox" style="padding-top: 60px">四大引擎 引爆需求</div>
        <p class="title_fu">1.5万亿儿童乐园“大蛋糕”呼之欲出</p>
        <img style="margin-top: 10px;" src="../../static/img/biaoti.png" alt="">
      </div>


      <div class="" style="width: 1300px;height:600px;margin:0 auto;margin-top: 50px">
        <div style="float: left;margin-right: 15px;width: 48%;margin-top: 74px" >
          <img src="../../static/img/wan1.png" alt="" style="float: left">
          <div style="float: left;margin-left:15px; ">
            <p style="color: #EA5C48;font-size: 24px;text-align: left">玩    是儿童乃至人类的天性</p>
            <div style="text-align:left;font-size: 14px;color: #666666;line-height: 25px;margin-top: 10px">
              <p style="color: #666">儿童乐园的需求始终存在，因为玩是儿童乃至人类的天性。人类在 </p>
              <p style="color: #666">玩乐的过程中认识、发现、了解、探索世界，在玩的过程中体会新奇、</p>
              <p style="color: #666">乐趣、心与幸福。所以，无论多大的孩子，没有不去游乐园的！</p>

             </div>
          </div>
        </div>
        <div style="float: left;;width: 48%;margin-top: 74px" >
          <img src="../../static/img/san1.png" alt="" style="float: left">
          <div style="float: left;margin-left:15px; ">
            <p style="color: #EA5C48;font-size: 24px;text-align: left">三胎开放      每年新增人口1600万</p>
            <div style="text-align:left;font-size: 14px;color: #666666;line-height: 25px;margin-top: 10px">
              <p style="color: #666">二胎政策放开，迎来了第一波生育高潮。三胎放开，第二波生育高潮说来 </p>
              <p style="color: #666">就来。人口红利再现，围绕儿童游乐的主题公园、游乐场所迎来需求井喷</p>
              <p style="color: #666">更是难得一遇的风口商机！</p>

            </div>
          </div>
        </div>
        <div style="float: left;margin-right: 15px;width: 48%;margin-top: 74px" >
          <img src="../../static/img/ren1.png" alt="" style="float: left">
          <div style="float: left;margin-left:15px; ">
            <p style="color: #EA5C48;font-size: 24px;text-align: left">庞大基数         儿童乐园产业迎来大爆发时代</p>
            <div style="text-align:left;font-size: 14px;color: #666666;line-height: 25px;margin-top: 10px">
              <p style="color: #666">80、90、00后已成主体消费人群，他们的孩子享受着来自父母和祖父</p>
              <p style="color: #666">辈的集中关爱，家庭财富向孩子们身上倾斜，4+2家庭结构，出现</p>
              <p style="color: #666">六个钱包给一个孩子花的情况。同时，新生代父母自我意识强，对品味、</p>
              <p style="color: #666">健康极为关注，更有创新精神的儿童品牌将会越来越受欢迎!</p>

            </div>
          </div>
        </div>
        <div style="float: left;width: 48%;margin-top: 74px" >
          <img src="../../static/img/go1.png" alt="" style="float: left">
          <div style="float: left;margin-left:15px; ">
            <p style="color: #EA5C48;font-size: 24px;text-align: left">庞大基数      儿童乐园产业迎来大爆发时代</p>
            <div style="text-align:left;font-size: 14px;color: #666666;line-height: 25px;margin-top: 10px">
              <p style="color: #666">据国际统计局数据显示，0-14岁儿童及少年超3亿人。与生俱来的需求</p>
              <p style="color: #666">加上各种政策的大力倾斜扶持，儿童产业产值水涨船高，预计到2025年</p>
              <p style="color: #666">有望突破1.5万亿大关！</p>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="banner_cai" id="fzlc" v-show="cur=='行业趋势'" style="width: 1300px;margin: 0 auto;height: 1150px;">
      <div style="text-align: center">
        <div class="titlebox" style="padding-top: 60px;color: #000">五大趋势引领儿童乐园+时代</div>
        <p class="title_fu" style="color: #000">trend</p>
        <img style="margin-top: 10px;" src="../../static/img/biaoti.png" alt="">
      </div>
      <div style="margin-top: 50px;margin-bottom: 50px">
        <img src="../../static/img/sbanner.png" alt="">
      </div>
      <div class="boxjoinus" style="width: 1268px;height: 70px;border: 1px solid #d9d9d9;padding: 15px;margin-top: 20px">
        <div style="float: left;border-right: 2px solid #EA5C48;padding-right: 15px">
          <p style="font-size: 30px;color: #EA5C48">品牌化</p>
          <p style="color: #EA5C48">发展的基石</p>
        </div>
        <div style="padding-top: 1px;line-height: 30px;
    padding-left: 15px;float: left;color: #666;width: 1137px;text-align: left">品牌，是消费者认知与肯定的关键，是综合实力的体现，是可持续发展的基石。因此，儿童乐园产业一样需要品牌化，有了品牌才可以在市场上扩大产品的竞争力，
          靠市场占有率可以取得更好的商业资源。</div>
      </div>
      <div class="boxjoinus" style="width: 1268px;height: 70px;border: 1px solid #d9d9d9;padding: 15px;margin-top: 20px">
        <div style="float: left;border-right: 2px solid #EA5C48;padding-right: 15px">
          <p style="font-size: 30px;color: #EA5C48">规模化</p>
          <p style="color: #EA5C48">竞争的法宝</p>
        </div>
        <div style="padding-top: 15px;line-height: 30px;
    padding-left: 15px;float: left;color: #666;width: 1137px;text-align: left">任一产业只有规模化才能长久繁盛，规模化的背后是流程标准化、成本更低、效率更好。儿童乐园何止千万家，为什么迪士尼方特能独占鳌头，靠的就是规模化。</div>
      </div>

      <div class="boxjoinus" style="width: 1268px;height: 70px;border: 1px solid #d9d9d9;padding: 15px;margin-top: 20px">
        <div style="float: left;border-right: 2px solid #EA5C48;padding-right: 15px">
          <p style="font-size: 30px;color: #EA5C48">情感化</p>
          <p style="color: #EA5C48">动人的灵魂</p>
        </div>
        <div style="padding-top: 1px;line-height: 30px;
    padding-left: 15px;float: left;color: #666;width: 1137px;text-align: left">儿童游乐园，不是寄放孩子的地方，也不是打发时间的地方，而是让孩子快乐玩耍的空间，更是身心灵愉快成长的承载，还是亲子游戏、情感升华的载体。所以，
          有故事、有态度、有温情、有互动、有成长才是乐园存在的意义所在。</div>
      </div>
      <div class="boxjoinus" style="width: 1268px;height: 70px;border: 1px solid #d9d9d9;padding: 15px;margin-top: 20px">
        <div style="float: left;border-right: 2px solid #EA5C48;padding-right: 15px">
          <p style="font-size: 30px;color: #EA5C48">融合化</p>
          <p style="color: #EA5C48">创新的必须</p>
        </div>
        <div style="padding-top: 1px;line-height: 30px;
    padding-left: 15px;float: left;color: #666;width: 1137px;text-align: left">单一的儿童乐园势单力薄，缺失了吸引孩子和大人的魅力，更谈不上与时俱进的模式创新。多业态融合，各资源互补，给孩子提供一个可以玩耍、可以快乐、可
          以成长的幸福场地。与此同时，多业态的融合在强力吸引消费者的同时，也极大的拓展了经营者的盈利渠道和利润空间！</div>
      </div>
      <div class="boxjoinus" style="width: 1268px;height: 70px;border: 1px solid #d9d9d9;padding: 15px;margin-top: 20px">
        <div style="float: left;border-right: 2px solid #EA5C48;padding-right: 15px">
          <p style="font-size: 30px;color: #EA5C48">专业化</p>
          <p style="color: #EA5C48">持久的动力</p>
        </div>
        <div style="padding-top: 15px;line-height: 30px;
    padding-left: 15px;float: left;color: #666;width: 1137px;text-align: left">儿童乐园要个性化，要多样化，同样需要专业化。包括专业的设计、专业的生产、专业的搭建、专业的人员、专业的服务以及专业的管理。唯有专业，方能持久。</div>
      </div>
    </div>

    <div class="box8" id="gsjj" v-show="cur=='投资优势'" >
      <div style="width: 1300px;text-align: center;margin: 0 auto">
        <div class="titlebox" style="padding-top: 60px">创业孵化器 财富收割机</div>
        <p class="title_fu" style="padding-top: 10px">一店多开 N种盈利渠道引爆中小本创业投资新格局</p>
        <img style="margin-top: 10px;text-align: center" src="../../static/img/biaoti.png" alt="">
      </div>
      <div>
        <div class="" style="width: 1300px;height:950px;margin:0 auto;">
          <div style="float: left;margin-right: 15px;width: 46%;margin-top: 30px" class="boxhh">
            <img src="../../static/img/55.png" alt="" style="float: left">
            <div style="float: left;margin-left:15px; ">
              <p style="color: #000;font-size: 24px;text-align: left"> 行业创始品牌</p>
              <div style="text-align:left;font-size: 14px;color: #666666;line-height: 25px;margin-top: 10px">
                <p style="color: #666">近20年沉淀，开心玩国在儿童产业深耕挖掘，已经积累的强大的品牌 </p>
                <p style="color: #666">影响力和市场号召力。是创始者，也是引领者。</p>
              </div>
            </div>
          </div>
          <div style="float: left;;width: 46%;margin-top: 30px"class="boxhh" >
            <img src="../../static/img/99.png" alt="" style="float: left">
            <div style="float: left;margin-left:15px; ">
              <p style="color: #000;font-size: 24px;text-align: left"> 儿童科学玩乐研究中心</p>
              <div style="text-align:left;font-size: 14px;color: #666666;line-height: 25px;margin-top: 10px">
                <p style="color: #666">专注专业，用更科学的理念和方式，深入探索儿童玩乐的真谛，带给孩</p>
                <p style="color: #666">子身心智的全面提升和成长。</p>

              </div>
            </div>
          </div>
          <div style="float: left;margin-right: 15px;width: 46%;margin-top: 30px" class="boxhh">
            <img src="../../static/img/22.png" alt="" style="float: left">
            <div style="float: left;margin-left:15px; ">
              <p style="color: #000;font-size: 24px;text-align: left"> 大师级实战营销</p>
              <div style="text-align:left;font-size: 14px;color: #666666;line-height: 25px;margin-top: 10px">
                <p style="color: #666">线上线下双线并行，新OTO实体实践者，注重理念创新、模式创新，</p>
                <p style="color: #666">更擅长实战突破。开心玩国产品优秀，营销更是业界高手。</p>

              </div>
            </div>
          </div>

          <div style="float: left;margin-right: 15px;width: 46%;margin-top: 30px" class="boxhh">
            <img src="../../static/img/77.png" alt="" style="float: left">
            <div style="float: left;margin-left:15px; ">
              <p style="color: #000000;font-size: 24px;text-align: left">创新模式引领新格局</p>
              <div style="text-align:left;font-size: 14px;color: #666666;line-height: 25px;margin-top: 10px">
                <p style="color: #666">泛产业大融合，创新模式整合，儿童游乐综合体的乐园+时代来临。不</p>
                <p style="color: #666">论是品牌还是规模，不论是人气还是经营，都将得到跨越式发展，引</p>
                <p style="color: #666">领产业新格局。</p>

              </div>
            </div>
          </div>
          <div style="float: left;margin-right: 15px;width: 46%;margin-top: 30px" class="boxhh">
            <img src="../../static/img/11.png" alt="" style="float: left">
            <div style="float: left;margin-left:15px; ">
              <p style="color: #000000;font-size: 24px;text-align: left">市场巨大红利来袭</p>
              <div style="text-align:left;font-size: 14px;color: #666666;line-height: 25px;margin-top: 10px">
                <p style="color: #666">3亿儿童构筑的游乐市场，是一座“储量”惊人的巨大“金矿”，蕴藏</p>
                <p style="color: #666">着无限商机，这种价值正在随着消费升级以及三胎放开的人口红利迅</p>
                <p style="color: #666">猛释放。</p>

              </div>
            </div>
          </div>
          <div style="float: left;margin-right: 15px;width: 46%;margin-top: 30px" class="boxhh">
            <img src="../../static/img/33.png" alt="" style="float: left">
            <div style="float: left;margin-left:15px; ">
              <p style="color: #000000;font-size: 24px;text-align: left">持久回报受益一生</p>
              <div style="text-align:left;font-size: 14px;color: #666666;line-height: 25px;margin-top: 10px">
                <p style="color: #666">从产业生命周期角度看，儿童产业是朝阳产业，更是常青产业。儿童游乐</p>
                <p style="color: #666">可以说是非常典型的高频、刚需，这一特征决定了儿童产业，是持续投资</p>
                <p style="color: #666">长期回报的产业。</p>

              </div>
            </div>
          </div>
          <div style="float: left;margin-right: 15px;width: 46%;margin-top: 30px" class="boxhh">
            <img src="../../static/img/88.png" alt="" style="float: left">
            <div style="float: left;margin-left:15px; ">
              <p style="color: #000000;font-size: 24px;text-align: left">盈利空间N倍拓展</p>
              <div style="text-align:left;font-size: 14px;color: #666666;line-height: 25px;margin-top: 10px">
                <p style="color: #666">六大主题空间，十大精选项目，对应的是N种盈利渠道，门票、会员卡、</p>
                <p style="color: #666">玩具、早教、体能培训、活动费、餐饮、百货……盈利空间何止是10倍 </p>
                <p style="color: #666">20倍增长！</p>

              </div>
            </div>
          </div>
          <div style="float: left;margin-right: 15px;width: 46%;margin-top: 30px" class="boxhh">
            <img src="../../static/img/66.png" alt="" style="float: left">
            <div style="float: left;margin-left:15px; ">
              <p style="color: #000;font-size: 24px;text-align: left"> 一站式服务解决方案</p>
              <div style="text-align:left;font-size: 14px;color: #666666;line-height: 25px;margin-top: 10px">
                <p style="color: #666">从市调到选址，从开店到设计，从营销到管理，开心玩国儿童乐园+为所 </p>
                <p style="color: #666">有合作伙伴，提供的一站式解决服务方案，从政策到落地执行，无微不至</p>
                <p style="color: #666">贯穿全程。</p>

              </div>
            </div>
          </div>
          <div style="float: left;margin-right: 15px;width: 46%;margin-top: 30px" class="boxhh">
            <img src="../../static/img/44.png" alt="" style="float: left">
            <div style="float: left;margin-left:15px; ">
              <p style="color: #000000;font-size: 24px;text-align: left"> 承诺式连锁实践者</p>
              <div style="text-align:left;font-size: 14px;color: #666666;line-height: 25px;margin-top: 10px">
                <p style="color: #666">所有合作店铺都有总部专业督导下店手把手指导运营，确保成功盈</p>
                <p style="color: #666">利。敢承诺重落地，真正敢说更敢做的儿童乐园连锁大品牌。真正无</p>
                <p style="color: #666">忧创业。</p>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Profooter></Profooter>
  </div>

</template>

<script>
import {goAnchor,GetQueryString} from '../../static/js/common';
import Prohead from '../components/Prohead'
import Profooter from "../components/Profooter";
import Swiper from "swiper";
export default {
  name: "index",
  components: {Prohead,Profooter},
  data () {
    return {
      cur: '市场前景',
      tabTitle:[{
        cate_name:'市场前景'
      },{
        cate_name:'行业趋势'
      },{
        cate_name:'投资优势'
      }],
      activeIndex: '1',
      activeIndex2: '1',
      changeRed:0,
      fullpath:''
    }
  },

  watch: {
    $route(to, from) {
      console.log('lalala',this.$route.query.id)
      if(this.$route.query.id == undefined){
        this.cur = '市场前景'
      }else{
        if (this.$route.query.id) {
          console.log('12131231',this.$route.query.id)

          this.cur = this.$route.query.id
        }
      }

    }
  },

  created() {
    this.cur = '市场前景'

  },
  mounted() {
    new Swiper ('.swiper-container', {
      slidesPerView: 3,
      spaceBetween: 30,
      loop: true,
      // 如果需要分页器
      // 如果需要前进后退按钮
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev',
      // 如果需要滚动条
      // scrollbar: '.swiper-scrollbar',
      //如果需要自动切换海报
      // autoplay: {
      //   delay: 1000,//时间 毫秒
      //   disableOnInteraction: false,//用户操作之后是否停止自动轮播默认true
      // },
    })
    this.$nextTick(() => {
      let maodian=this.GetQueryString('maodian');//进入页面，如果带有锚点参数，则跳转至锚点地方，参数值就是id名
      if(maodian){
        this.goAnchor('#'+maodian);

      }
    });

  },
  methods:{
    beforeRouteEnter(to, from, next) {
      next(vm => {
        // 通过 `vm` 访问fetchData，将query参数name，传递过去，进行逻辑处理
        // debugger
        // console.log(to)
        // console.log(from)
        //       console.log(vm.$route); //有值
        //       next()
        if (from.fullPath === "****") {  //关键判断这里区别，自己刷新是 /
          vm.fullpath = from.fullPath;
          this.$router.go(0);
        }

        // vm.fetchData(vm.$route.query.name);
      });
    },
    goAnchor,

    GetQueryString,

  },
}
</script>

<style scoped>
.boxhh{

  padding: 15px;
}
.boxhh:hover{
  background: rgba(194, 194, 194, 0.1);
  cursor: pointer;
}
.tab-title{
  width: 1300px;
  height: 100px;
  margin: 0 auto
}
.tab-title li:hover{
  cursor: pointer;
}
.tab-title li{
  width: 180px;
  height: 60px;
  border-radius: 30px;
  float: left;
  border: 1px solid #C5C5C5;
  line-height: 60px;
  text-align: center;
  margin-right: 20px;
  font-size: 18px;
}
.tab-title .active{
  background: #EA5C48;
  color: white;
  cursor: pointer;
  border: 1px solid #EA5C48;

}
.linear-link{
  position: absolute;
  font-size: 20px;
  top: 180px;
  font-family: PingFang;
  color: #FFFFFF;
  width: 252px;
  opacity: 0.9;
  text-align: center;
  border-radius: 10px !important;
  line-height: 50px;
}
.solution {
  margin-bottom: 10px;
}
.solution .media-img:hover .mask {
  z-index: 5;
  transition: 0.3s;
  opacity: 1;
  transform: scale(1.1);
}
.solution .media-img:hover .mask {
  z-index: 5;
  transition: 0.3s;
  opacity: 1;
  transform: scale(1.1);
}
.solution .media-img .mask {
  opacity: 0;
  z-index: 3;
  width: 92%;
  height: 92%;
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  transition: 0.3s;
  margin-left: 11px;
  margin-top: 12px;
}
.solution .media-img {
  position: relative;
  //width: 252px;
  //height: 320px;
}
.solution .media-img .mask .subtitle {
  padding: 25px;
  color: #ffffff;
}t
.box8{
  text-align: center;
}
.box8 .box8_banner{
  margin: 0 auto;
  width: 1300px;
  height: 550px;
}
.banner_cai{
  height: 600px;
}
.banner_pin div{
  float: left;
}
.boxyin_banner{
  width: 1400px;
  height:480px;
  margin: 0 auto;
  padding-top:68px ;

}
.boxyin_banner img{
  padding-top: 56px;
}
.boxyin_banner p{
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 40px;
}
.boxyin_banner div{
  //width: 270px;
  //height: 320px;
  //background: #26B0C0;
  //box-shadow: 0px 10px 10px 0px rgba(38, 176, 192, 0.1);
  //border-radius: 10px;
  //float: left;
  //margin-right: 70px;
  //text-align: center;
}
.box3{
  margin: 0 auto;
  width: 100%;
  height: 618px;
  //background: url("../../static/img/bg2.jpg");
}
.box_banner2{
  width: 1300px;
  margin: 0 auto;
  height: 620px;
  text-align: center;
}
.box_imgbanner div{
  float: left;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 36px;
  text-align: left;
}
.box_imgbanner{
  margin-top: 60px;
}
.banner_pintext{
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
}
.titlebox{
  text-align: center;
  font-size: 40px;
  font-weight: 500;
}
.title_fu{
  font-size: 18px;
  font-weight: 400;
  color: #666666;
  text-align: center;
}
.banner{
  height: 300px;
  font-size: 40px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 300px;
  text-align: center;
}
.banner_kai{
  width: 1300px;
  height: 894px;
  margin: 0 auto;
}
.solution{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Proadd.vue